import React from 'react';
import { GlobalToken } from 'antd';
import { LegendLabelStyled } from './LegendLabel.styles';

export const LegendLabel = ({ name, token }: { name: string; token: GlobalToken }) => {
  return <LegendLabelStyled $fontSize={token.fontSizeSM}>{name}</LegendLabelStyled>;
};
